import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { PrismicDocument } from '@prismicio/client';
import { EMPTY, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { StandardPage, StandardService } from './standard.service';

export const standardResolver: ResolveFn<Observable<PrismicDocument<StandardPage>>> = (route) => {
    const locale = route.data['locale'];
    const standardService = inject(StandardService);
    const router = inject(Router);

    const uidParam = route.paramMap.get('uid') || route.data['uid'];
    const subUidParam = route.paramMap.get('subUid');

    const uid = subUidParam ? `${uidParam}.${subUidParam}` : uidParam || route.data['uid'] || '';

    return standardService.getStandardPage(uid, locale).pipe(
        catchError(() => {
            router.navigate(['/seite-nicht-gefunden']);
            return EMPTY;
        })
    );
};
